
export const BANKS = [
    {
        "id": 17,
        "bankName": "Ngân hàng TMCP Công thương Việt Nam",
        "bankCode": "ICB",
        "bin": "970415",
        "bankShortName": "VietinBank",
        "logo": "https://api.vietqr.io/img/ICB.png",
        "transferSupported": 1,
        "lookupSupported": 1,
        "short_name": "VietinBank",
        "support": 3,
        "isTransfer": 1,
        "swift_code": "ICBVVNVX"
    },
    {
        "id": 43,
        "bankName": "Ngân hàng TMCP Ngoại Thương Việt Nam",
        "bankCode": "VCB",
        "bin": "970436",
        "bankShortName": "Vietcombank",
        "logo": "https://api.vietqr.io/img/VCB.png",
        "transferSupported": 1,
        "lookupSupported": 1,
        "short_name": "Vietcombank",
        "support": 3,
        "isTransfer": 1,
        "swift_code": "BFTVVNVX"
    },
    {
        "id": 4,
        "bankName": "Ngân hàng TMCP Đầu tư và Phát triển Việt Nam",
        "bankCode": "BIDV",
        "bin": "970418",
        "bankShortName": "BIDV",
        "logo": "https://api.vietqr.io/img/BIDV.png",
        "transferSupported": 1,
        "lookupSupported": 1,
        "short_name": "BIDV",
        "support": 3,
        "isTransfer": 1,
        "swift_code": "BIDVVNVX"
    },
    {
        "id": 42,
        "bankName": "Ngân hàng Nông nghiệp và Phát triển Nông thôn Việt Nam",
        "bankCode": "VBA",
        "bin": "970405",
        "bankShortName": "Agribank",
        "logo": "https://api.vietqr.io/img/VBA.png",
        "transferSupported": 1,
        "lookupSupported": 1,
        "short_name": "Agribank",
        "support": 3,
        "isTransfer": 1,
        "swift_code": "VBAAVNVX"
    },
    {
        "id": 26,
        "bankName": "Ngân hàng TMCP Phương Đông",
        "bankCode": "OCB",
        "bin": "970448",
        "bankShortName": "OCB",
        "logo": "https://api.vietqr.io/img/OCB.png",
        "transferSupported": 1,
        "lookupSupported": 1,
        "short_name": "OCB",
        "support": 3,
        "isTransfer": 1,
        "swift_code": "ORCOVNVX"
    },
    {
        "id": 21,
        "bankName": "Ngân hàng TMCP Quân đội",
        "bankCode": "MB",
        "bin": "970422",
        "bankShortName": "MBBank",
        "logo": "https://api.vietqr.io/img/MB.png",
        "transferSupported": 1,
        "lookupSupported": 1,
        "short_name": "MBBank",
        "support": 3,
        "isTransfer": 1,
        "swift_code": "MSCBVNVX"
    },
    {
        "id": 38,
        "bankName": "Ngân hàng TMCP Kỹ thương Việt Nam",
        "bankCode": "TCB",
        "bin": "970407",
        "bankShortName": "Techcombank",
        "logo": "https://api.vietqr.io/img/TCB.png",
        "transferSupported": 1,
        "lookupSupported": 1,
        "short_name": "Techcombank",
        "support": 3,
        "isTransfer": 1,
        "swift_code": "VTCBVNVX"
    },
    {
        "id": 2,
        "bankName": "Ngân hàng TMCP Á Châu",
        "bankCode": "ACB",
        "bin": "970416",
        "bankShortName": "ACB",
        "logo": "https://api.vietqr.io/img/ACB.png",
        "transferSupported": 1,
        "lookupSupported": 1,
        "short_name": "ACB",
        "support": 3,
        "isTransfer": 1,
        "swift_code": "ASCBVNVX"
    },
    {
        "id": 47,
        "bankName": "Ngân hàng TMCP Việt Nam Thịnh Vượng",
        "bankCode": "VPB",
        "bin": "970432",
        "bankShortName": "VPBank",
        "logo": "https://api.vietqr.io/img/VPB.png",
        "transferSupported": 1,
        "lookupSupported": 1,
        "short_name": "VPBank",
        "support": 3,
        "isTransfer": 1,
        "swift_code": "VPBKVNVX"
    },
    {
        "id": 39,
        "bankName": "Ngân hàng TMCP Tiên Phong",
        "bankCode": "TPB",
        "bin": "970423",
        "bankShortName": "TPBank",
        "logo": "https://api.vietqr.io/img/TPB.png",
        "transferSupported": 1,
        "lookupSupported": 1,
        "short_name": "TPBank",
        "support": 3,
        "isTransfer": 1,
        "swift_code": "TPBVVNVX"
    },
    {
        "id": 36,
        "bankName": "Ngân hàng TMCP Sài Gòn Thương Tín",
        "bankCode": "STB",
        "bin": "970403",
        "bankShortName": "Sacombank",
        "logo": "https://api.vietqr.io/img/STB.png",
        "transferSupported": 1,
        "lookupSupported": 1,
        "short_name": "Sacombank",
        "support": 3,
        "isTransfer": 1,
        "swift_code": "SGTTVNVX"
    },
    {
        "id": 12,
        "bankName": "Ngân hàng TMCP Phát triển Thành phố Hồ Chí Minh",
        "bankCode": "HDB",
        "bin": "970437",
        "bankShortName": "HDBank",
        "logo": "https://api.vietqr.io/img/HDB.png",
        "transferSupported": 1,
        "lookupSupported": 1,
        "short_name": "HDBank",
        "support": 3,
        "isTransfer": 1,
        "swift_code": "HDBCVNVX"
    },
    {
        "id": 44,
        "bankName": "Ngân hàng TMCP Bản Việt",
        "bankCode": "VCCB",
        "bin": "970454",
        "bankShortName": "VietCapitalBank",
        "logo": "https://api.vietqr.io/img/VCCB.png",
        "transferSupported": 1,
        "lookupSupported": 1,
        "short_name": "VietCapitalBank",
        "support": 3,
        "isTransfer": 1,
        "swift_code": "VCBCVNVX"
    },
    {
        "id": 31,
        "bankName": "Ngân hàng TMCP Sài Gòn",
        "bankCode": "SCB",
        "bin": "970429",
        "bankShortName": "SCB",
        "logo": "https://api.vietqr.io/img/SCB.png",
        "transferSupported": 1,
        "lookupSupported": 1,
        "short_name": "SCB",
        "support": 3,
        "isTransfer": 1,
        "swift_code": "SACLVNVX"
    },
    {
        "id": 45,
        "bankName": "Ngân hàng TMCP Quốc tế Việt Nam",
        "bankCode": "vib-2",
        "bin": "970441",
        "bankShortName": "VIB",
        "logo": "https://api.vietqr.io/img/VIB.png",
        "transferSupported": 1,
        "lookupSupported": 1,
        "short_name": "VIB",
        "support": 3,
        "isTransfer": 1,
        "swift_code": "VNIBVNVX"
    },
    {
        "id": 35,
        "bankName": "Ngân hàng TMCP Sài Gòn - Hà Nội",
        "bankCode": "SHB",
        "bin": "970443",
        "bankShortName": "SHB",
        "logo": "https://api.vietqr.io/img/SHB.png",
        "transferSupported": 1,
        "lookupSupported": 1,
        "short_name": "SHB",
        "support": 3,
        "isTransfer": 1,
        "swift_code": "SHBAVNVX"
    },
    {
        "id": 10,
        "bankName": "Ngân hàng TMCP Xuất Nhập khẩu Việt Nam",
        "bankCode": "EIB",
        "bin": "970431",
        "bankShortName": "Eximbank",
        "logo": "https://api.vietqr.io/img/EIB.png",
        "transferSupported": 1,
        "lookupSupported": 1,
        "short_name": "Eximbank",
        "support": 3,
        "isTransfer": 1,
        "swift_code": "EBVIVNVX"
    },
    {
        "id": 22,
        "bankName": "Ngân hàng TMCP Hàng Hải",
        "bankCode": "MSB",
        "bin": "970426",
        "bankShortName": "MSB",
        "logo": "https://api.vietqr.io/img/MSB.png",
        "transferSupported": 1,
        "lookupSupported": 1,
        "short_name": "MSB",
        "support": 3,
        "isTransfer": 1,
        "swift_code": "MCOBVNVX"
    },
    {
        "id": 53,
        "bankName": "TMCP Việt Nam Thịnh Vượng - Ngân hàng số CAKE by VPBank",
        "bankCode": "CAKE",
        "bin": "546034",
        "bankShortName": "CAKE",
        "logo": "https://api.vietqr.io/img/CAKE.png",
        "transferSupported": 1,
        "lookupSupported": 1,
        "short_name": "CAKE",
        "support": 3,
        "isTransfer": 1,
        "swift_code": null
    },
    {
        "id": 54,
        "bankName": "TMCP Việt Nam Thịnh Vượng - Ngân hàng số Ubank by VPBank",
        "bankCode": "Ubank",
        "bin": "546035",
        "bankShortName": "Ubank",
        "logo": "https://api.vietqr.io/img/UBANK.png",
        "transferSupported": 1,
        "lookupSupported": 1,
        "short_name": "Ubank",
        "support": 3,
        "isTransfer": 1,
        "swift_code": null
    },
    {
        "id": 58,
        "bankName": "Ngân hàng số Timo by Ban Viet Bank (Timo by Ban Viet Bank)",
        "bankCode": "TIMO",
        "bin": "963388",
        "bankShortName": "Timo",
        "logo": "https://vietqr.net/portal-service/resources/icons/TIMO.png",
        "transferSupported": 1,
        "lookupSupported": 0,
        "short_name": "Timo",
        "support": 0,
        "isTransfer": 1,
        "swift_code": null
    },
    {
        "id": 57,
        "bankName": "Tổng Công ty Dịch vụ số Viettel - Chi nhánh tập đoàn công nghiệp viễn thông Quân Đội",
        "bankCode": "VTLMONEY",
        "bin": "971005",
        "bankShortName": "ViettelMoney",
        "logo": "https://api.vietqr.io/img/VIETTELMONEY.png",
        "transferSupported": 0,
        "lookupSupported": 1,
        "short_name": "ViettelMoney",
        "support": 0,
        "isTransfer": 0,
        "swift_code": null
    },
    {
        "id": 56,
        "bankName": "VNPT Money",
        "bankCode": "VNPTMONEY",
        "bin": "971011",
        "bankShortName": "VNPTMoney",
        "logo": "https://api.vietqr.io/img/VNPTMONEY.png",
        "transferSupported": 0,
        "lookupSupported": 1,
        "short_name": "VNPTMoney",
        "support": 0,
        "isTransfer": 0,
        "swift_code": null
    },
    {
        "id": 34,
        "bankName": "Ngân hàng TMCP Sài Gòn Công Thương",
        "bankCode": "SGICB",
        "bin": "970400",
        "bankShortName": "SaigonBank",
        "logo": "https://api.vietqr.io/img/SGICB.png",
        "transferSupported": 1,
        "lookupSupported": 1,
        "short_name": "SaigonBank",
        "support": 3,
        "isTransfer": 1,
        "swift_code": "SBITVNVX"
    },
    {
        "id": 3,
        "bankName": "Ngân hàng TMCP Bắc Á",
        "bankCode": "BAB",
        "bin": "970409",
        "bankShortName": "BacABank",
        "logo": "https://api.vietqr.io/img/BAB.png",
        "transferSupported": 1,
        "lookupSupported": 1,
        "short_name": "BacABank",
        "support": 3,
        "isTransfer": 1,
        "swift_code": "NASCVNVX"
    },
    {
        "id": 30,
        "bankName": "Ngân hàng TMCP Đại Chúng Việt Nam",
        "bankCode": "PVCB",
        "bin": "970412",
        "bankShortName": "PVcomBank",
        "logo": "https://api.vietqr.io/img/PVCB.png",
        "transferSupported": 1,
        "lookupSupported": 1,
        "short_name": "PVcomBank",
        "support": 3,
        "isTransfer": 1,
        "swift_code": "WBVNVNVX"
    },
    {
        "id": 27,
        "bankName": "Ngân hàng Thương mại TNHH MTV Đại Dương",
        "bankCode": "Oceanbank",
        "bin": "970414",
        "bankShortName": "Oceanbank",
        "logo": "https://api.vietqr.io/img/OCEANBANK.png",
        "transferSupported": 1,
        "lookupSupported": 1,
        "short_name": "Oceanbank",
        "support": 3,
        "isTransfer": 1,
        "swift_code": "OCBKUS3M"
    },
    {
        "id": 24,
        "bankName": "Ngân hàng TMCP Quốc Dân",
        "bankCode": "NCB",
        "bin": "970419",
        "bankShortName": "NCB",
        "logo": "https://api.vietqr.io/img/NCB.png",
        "transferSupported": 1,
        "lookupSupported": 1,
        "short_name": "NCB",
        "support": 3,
        "isTransfer": 1,
        "swift_code": "NVBAVNVX"
    },
    {
        "id": 37,
        "bankName": "Ngân hàng TNHH MTV Shinhan Việt Nam",
        "bankCode": "SHBVN",
        "bin": "970424",
        "bankShortName": "ShinhanBank",
        "logo": "https://api.vietqr.io/img/SHBVN.png",
        "transferSupported": 1,
        "lookupSupported": 1,
        "short_name": "ShinhanBank",
        "support": 3,
        "isTransfer": 1,
        "swift_code": "SHBKVNVX"
    },
    {
        "id": 1,
        "bankName": "Ngân hàng TMCP An Bình",
        "bankCode": "ABB",
        "bin": "970425",
        "bankShortName": "ABBANK",
        "logo": "https://api.vietqr.io/img/ABB.png",
        "transferSupported": 1,
        "lookupSupported": 1,
        "short_name": "ABBANK",
        "support": 3,
        "isTransfer": 1,
        "swift_code": "ABBKVNVX"
    },
    {
        "id": 41,
        "bankName": "Ngân hàng TMCP Việt Á",
        "bankCode": "VAB",
        "bin": "970427",
        "bankShortName": "VietABank",
        "logo": "https://api.vietqr.io/img/VAB.png",
        "transferSupported": 1,
        "lookupSupported": 1,
        "short_name": "VietABank",
        "support": 3,
        "isTransfer": 1,
        "swift_code": "VNACVNVX"
    },
    {
        "id": 23,
        "bankName": "Ngân hàng TMCP Nam Á",
        "bankCode": "NAB",
        "bin": "970428",
        "bankShortName": "NamABank",
        "logo": "https://api.vietqr.io/img/NAB.png",
        "transferSupported": 1,
        "lookupSupported": 1,
        "short_name": "NamABank",
        "support": 3,
        "isTransfer": 1,
        "swift_code": "NAMAVNVX"
    },
    {
        "id": 29,
        "bankName": "Ngân hàng TMCP Xăng dầu Petrolimex",
        "bankCode": "PGB",
        "bin": "970430",
        "bankShortName": "PGBank",
        "logo": "https://api.vietqr.io/img/PGB.png",
        "transferSupported": 1,
        "lookupSupported": 1,
        "short_name": "PGBank",
        "support": 3,
        "isTransfer": 1,
        "swift_code": "PGBLVNVX"
    },
    {
        "id": 46,
        "bankName": "Ngân hàng TMCP Việt Nam Thương Tín",
        "bankCode": "VIETBANK",
        "bin": "970433",
        "bankShortName": "VietBank",
        "logo": "https://api.vietqr.io/img/VIETBANK.png",
        "transferSupported": 1,
        "lookupSupported": 1,
        "short_name": "VietBank",
        "support": 3,
        "isTransfer": 1,
        "swift_code": "VNTTVNVX"
    },
    {
        "id": 5,
        "bankName": "Ngân hàng TMCP Bảo Việt",
        "bankCode": "BVB",
        "bin": "970438",
        "bankShortName": "BaoVietBank",
        "logo": "https://api.vietqr.io/img/BVB.png",
        "transferSupported": 1,
        "lookupSupported": 1,
        "short_name": "BaoVietBank",
        "support": 3,
        "isTransfer": 1,
        "swift_code": "BVBVVNVX"
    },
    {
        "id": 33,
        "bankName": "Ngân hàng TMCP Đông Nam Á",
        "bankCode": "SEAB",
        "bin": "970440",
        "bankShortName": "SeABank",
        "logo": "https://api.vietqr.io/img/SEAB.png",
        "transferSupported": 1,
        "lookupSupported": 1,
        "short_name": "SeABank",
        "support": 3,
        "isTransfer": 1,
        "swift_code": "SEAVVNVX"
    },
    {
        "id": 52,
        "bankName": "Ngân hàng Hợp tác xã Việt Nam",
        "bankCode": "COOPBANK",
        "bin": "970446",
        "bankShortName": "COOPBANK",
        "logo": "https://api.vietqr.io/img/COOPBANK.png",
        "transferSupported": 1,
        "lookupSupported": 1,
        "short_name": "COOPBANK",
        "support": 3,
        "isTransfer": 1,
        "swift_code": null
    },
    {
        "id": 20,
        "bankName": "Ngân hàng TMCP Bưu Điện Liên Việt",
        "bankCode": "LPB",
        "bin": "970449",
        "bankShortName": "LienVietPostBank",
        "logo": "https://api.vietqr.io/img/LPB.png",
        "transferSupported": 1,
        "lookupSupported": 1,
        "short_name": "LienVietPostBank",
        "support": 3,
        "isTransfer": 1,
        "swift_code": "LVBKVNVX"
    },
    {
        "id": 19,
        "bankName": "Ngân hàng TMCP Kiên Long",
        "bankCode": "KLB",
        "bin": "970452",
        "bankShortName": "KienLongBank",
        "logo": "https://api.vietqr.io/img/KLB.png",
        "transferSupported": 1,
        "lookupSupported": 1,
        "short_name": "KienLongBank",
        "support": 3,
        "isTransfer": 1,
        "swift_code": "KLBKVNVX"
    },
    {
        "id": 55,
        "bankName": "Ngân hàng Đại chúng TNHH Kasikornbank",
        "bankCode": "KBank",
        "bin": "668888",
        "bankShortName": "KBank",
        "logo": "https://api.vietqr.io/img/KBANK.png",
        "transferSupported": 1,
        "lookupSupported": 1,
        "short_name": "KBank",
        "support": 3,
        "isTransfer": 1,
        "swift_code": "KASIVNVX"
    },
    {
        "id": 40,
        "bankName": "Ngân hàng United Overseas - Chi nhánh TP. Hồ Chí Minh",
        "bankCode": "UOB",
        "bin": "970458",
        "bankShortName": "UnitedOverseas",
        "logo": "https://api.vietqr.io/img/UOB.png",
        "transferSupported": 0,
        "lookupSupported": 1,
        "short_name": "UnitedOverseas",
        "support": 0,
        "isTransfer": 0,
        "swift_code": null
    },
    {
        "id": 32,
        "bankName": "Ngân hàng TNHH MTV Standard Chartered Bank Việt Nam",
        "bankCode": "SCVN",
        "bin": "970410",
        "bankShortName": "StandardChartered",
        "logo": "https://api.vietqr.io/img/SCVN.png",
        "transferSupported": 0,
        "lookupSupported": 1,
        "short_name": "StandardChartered",
        "support": 0,
        "isTransfer": 0,
        "swift_code": "SCBLVNVX"
    },
    {
        "id": 28,
        "bankName": "Ngân hàng TNHH MTV Public Việt Nam",
        "bankCode": "PBVN",
        "bin": "970439",
        "bankShortName": "PublicBank",
        "logo": "https://api.vietqr.io/img/PBVN.png",
        "transferSupported": 0,
        "lookupSupported": 1,
        "short_name": "PublicBank",
        "support": 0,
        "isTransfer": 0,
        "swift_code": "VIDPVNVX"
    },
    {
        "id": 25,
        "bankName": "Ngân hàng Nonghyup - Chi nhánh Hà Nội",
        "bankCode": "NHB HN",
        "bin": "801011",
        "bankShortName": "Nonghyup",
        "logo": "https://api.vietqr.io/img/NHB.png",
        "transferSupported": 0,
        "lookupSupported": 0,
        "short_name": "Nonghyup",
        "support": 0,
        "isTransfer": 0,
        "swift_code": null
    },
    {
        "id": 18,
        "bankName": "Ngân hàng TNHH Indovina",
        "bankCode": "IVB",
        "bin": "970434",
        "bankShortName": "IndovinaBank",
        "logo": "https://api.vietqr.io/img/IVB.png",
        "transferSupported": 0,
        "lookupSupported": 1,
        "short_name": "IndovinaBank",
        "support": 0,
        "isTransfer": 0,
        "swift_code": null
    },
    {
        "id": 16,
        "bankName": "Ngân hàng Công nghiệp Hàn Quốc - Chi nhánh TP. Hồ Chí Minh",
        "bankCode": "IBK - HCM",
        "bin": "970456",
        "bankShortName": "IBKHCM",
        "logo": "https://api.vietqr.io/img/IBK.png",
        "transferSupported": 0,
        "lookupSupported": 0,
        "short_name": "IBKHCM",
        "support": 0,
        "isTransfer": 0,
        "swift_code": null
    },
    {
        "id": 15,
        "bankName": "Ngân hàng Công nghiệp Hàn Quốc - Chi nhánh Hà Nội",
        "bankCode": "IBK - HN",
        "bin": "970455",
        "bankShortName": "IBKHN",
        "logo": "https://api.vietqr.io/img/IBK.png",
        "transferSupported": 0,
        "lookupSupported": 0,
        "short_name": "IBKHN",
        "support": 0,
        "isTransfer": 0,
        "swift_code": null
    },
    {
        "id": 48,
        "bankName": "Ngân hàng Liên doanh Việt - Nga",
        "bankCode": "VRB",
        "bin": "970421",
        "bankShortName": "VRB",
        "logo": "https://api.vietqr.io/img/VRB.png",
        "transferSupported": 0,
        "lookupSupported": 1,
        "short_name": "VRB",
        "support": 0,
        "isTransfer": 0,
        "swift_code": null
    },
    {
        "id": 49,
        "bankName": "Ngân hàng TNHH MTV Woori Việt Nam",
        "bankCode": "WVN",
        "bin": "970457",
        "bankShortName": "Woori",
        "logo": "https://api.vietqr.io/img/WVN.png",
        "transferSupported": 1,
        "lookupSupported": 1,
        "short_name": "Woori",
        "support": 0,
        "isTransfer": 1,
        "swift_code": null
    },
    {
        "id": 50,
        "bankName": "Ngân hàng Kookmin - Chi nhánh Hà Nội",
        "bankCode": "KBHN",
        "bin": "970462",
        "bankShortName": "KookminHN",
        "logo": "https://api.vietqr.io/img/KBHN.png",
        "transferSupported": 0,
        "lookupSupported": 0,
        "short_name": "KookminHN",
        "support": 0,
        "isTransfer": 0,
        "swift_code": null
    },
    {
        "id": 51,
        "bankName": "Ngân hàng Kookmin - Chi nhánh Thành phố Hồ Chí Minh",
        "bankCode": "KBHCM",
        "bin": "970463",
        "bankShortName": "KookminHCM",
        "logo": "https://api.vietqr.io/img/KBHCM.png",
        "transferSupported": 0,
        "lookupSupported": 0,
        "short_name": "KookminHCM",
        "support": 0,
        "isTransfer": 0,
        "swift_code": null
    },
    {
        "id": 14,
        "bankName": "Ngân hàng TNHH MTV HSBC (Việt Nam)",
        "bankCode": "HSBC",
        "bin": "458761",
        "bankShortName": "HSBC",
        "logo": "https://api.vietqr.io/img/HSBC.png",
        "transferSupported": 0,
        "lookupSupported": 1,
        "short_name": "HSBC",
        "support": 0,
        "isTransfer": 0,
        "swift_code": "HSBCVNVX"
    },
    {
        "id": 13,
        "bankName": "Ngân hàng TNHH MTV Hong Leong Việt Nam",
        "bankCode": "HLBVN",
        "bin": "970442",
        "bankShortName": "HongLeong",
        "logo": "https://api.vietqr.io/img/HLBVN.png",
        "transferSupported": 0,
        "lookupSupported": 1,
        "short_name": "HongLeong",
        "support": 0,
        "isTransfer": 0,
        "swift_code": "HLBBVNVX"
    },
    {
        "id": 11,
        "bankName": "Ngân hàng Thương mại TNHH MTV Dầu Khí Toàn Cầu",
        "bankCode": "GPB",
        "bin": "970408",
        "bankShortName": "GPBank",
        "logo": "https://api.vietqr.io/img/GPB.png",
        "transferSupported": 0,
        "lookupSupported": 1,
        "short_name": "GPBank",
        "support": 0,
        "isTransfer": 0,
        "swift_code": "GBNKVNVX"
    },
    {
        "id": 9,
        "bankName": "Ngân hàng TMCP Đông Á",
        "bankCode": "DOB",
        "bin": "970406",
        "bankShortName": "DongABank",
        "logo": "https://api.vietqr.io/img/DOB.png",
        "transferSupported": 0,
        "lookupSupported": 1,
        "short_name": "DongABank",
        "support": 0,
        "isTransfer": 0,
        "swift_code": "EACBVNVX"
    },
    {
        "id": 8,
        "bankName": "DBS Bank Ltd - Chi nhánh Thành phố Hồ Chí Minh",
        "bankCode": "DBS",
        "bin": "796500",
        "bankShortName": "DBSBank",
        "logo": "https://api.vietqr.io/img/DBS.png",
        "transferSupported": 0,
        "lookupSupported": 0,
        "short_name": "DBSBank",
        "support": 0,
        "isTransfer": 0,
        "swift_code": "DBSSVNVX"
    },
    {
        "id": 7,
        "bankName": "Ngân hàng TNHH MTV CIMB Việt Nam",
        "bankCode": "CIMB",
        "bin": "422589",
        "bankShortName": "CIMB",
        "logo": "https://api.vietqr.io/img/CIMB.png",
        "transferSupported": 1,
        "lookupSupported": 1,
        "short_name": "CIMB",
        "support": 0,
        "isTransfer": 1,
        "swift_code": "CIBBVNVN"
    },
    {
        "id": 6,
        "bankName": "Ngân hàng Thương mại TNHH MTV Xây dựng Việt Nam",
        "bankCode": "CBB",
        "bin": "970444",
        "bankShortName": "CBBank",
        "logo": "https://api.vietqr.io/img/CBB.png",
        "transferSupported": 0,
        "lookupSupported": 1,
        "short_name": "CBBank",
        "support": 0,
        "isTransfer": 0,
        "swift_code": "GTBAVNVX"
    },
    {
        "id": 59,
        "bankName": "Ngân hàng Citibank, N.A. - Chi nhánh Hà Nội",
        "bankCode": "CITIBANK",
        "bin": "533948",
        "bankShortName": "Citibank",
        "logo": "https://api.vietqr.io/img/CITIBANK.png",
        "transferSupported": 0,
        "lookupSupported": 0,
        "short_name": "Citibank",
        "support": 0,
        "isTransfer": 0,
        "swift_code": null
    },
    {
        "id": 60,
        "bankName": "Ngân hàng KEB Hana – Chi nhánh Thành phố Hồ Chí Minh",
        "bankCode": "KEBHANAHCM",
        "bin": "970466",
        "bankShortName": "KEBHanaHCM",
        "logo": "https://api.vietqr.io/img/KEBHANAHCM.png",
        "transferSupported": 0,
        "lookupSupported": 0,
        "short_name": "KEBHanaHCM",
        "support": 0,
        "isTransfer": 0,
        "swift_code": null
    },
    {
        "id": 61,
        "bankName": "Ngân hàng KEB Hana – Chi nhánh Hà Nội",
        "bankCode": "KEBHANAHN",
        "bin": "970467",
        "bankShortName": "KEBHANAHN",
        "logo": "https://api.vietqr.io/img/KEBHANAHN.png",
        "transferSupported": 0,
        "lookupSupported": 0,
        "short_name": "KEBHANAHN",
        "support": 0,
        "isTransfer": 0,
        "swift_code": null
    },
    {
        "id": 62,
        "bankName": "Công ty Tài chính TNHH MTV Mirae Asset (Việt Nam) ",
        "bankCode": "MAFC",
        "bin": "977777",
        "bankShortName": "MAFC",
        "logo": "https://api.vietqr.io/img/MAFC.png",
        "transferSupported": 0,
        "lookupSupported": 0,
        "short_name": "MAFC",
        "support": 0,
        "isTransfer": 0,
        "swift_code": null
    },
    {
        "id": 63,
        "bankName": "Ngân hàng Chính sách Xã hội",
        "bankCode": "VBSP",
        "bin": "999888",
        "bankShortName": "VBSP",
        "logo": "https://api.vietqr.io/img/VBSP.png",
        "transferSupported": 0,
        "lookupSupported": 0,
        "short_name": "VBSP",
        "support": 0,
        "isTransfer": 0,
        "swift_code": null
    }
]
  